import { render, staticRenderFns } from "./index.vue?vue&type=template&id=60f0907e&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\progect\\guowai\\ex_express_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60f0907e')) {
      api.createRecord('60f0907e', component.options)
    } else {
      api.reload('60f0907e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=60f0907e&", function () {
      api.rerender('60f0907e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/management/xufei/index.vue"
export default component.exports